<template>
    <div class="flex items-center justify-between">
        <div class="text-base-content-subtle">
            {{ hitsPerPage <= nbHits ? hitsPerPage : nbHits }} {{ $t('search.input.of') }} {{ nbHits }} {{ $t('search.input.results') }}
        </div>
        <a
            href="javascript:void(0);"
            class="cursor-pointer no-underline flex items-center gap-1 p-1 font-bold focus:outline-outline-focus"
            tabindex="0"
            :title="$t('search.input.showAll')"
            data-cy="search-toolbar-show-all"
            @click="onShowAllResults()"
            @keydown.enter="onShowAllResults()"
        >
            {{ $t('search.input.showAll') }} <MiscIcon name="chevron-right" class="inline-block w-4 h-4" />
        </a>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    nbHits: number
    hitsPerPage: number
}>()

const emit = defineEmits(['onShowAllResults'])

function onShowAllResults () {
    emit('onShowAllResults', true)
}
</script>
